/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1BannerBanneridLangsQueryResponse,
  GetApiV1BannerBanneridLangsPathParams,
  GetApiV1BannerBanneridLangsQueryParams,
  GetApiV1BannerBanneridLangs401,
  GetApiV1BannerBanneridLangs404,
  GetApiV1BannerBanneridLangs500,
} from "../../types/bannerIdiomasController/GetApiV1BannerBanneridLangs.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1BannerBanneridLangs } from "../../clients/bannerIdiomasController/getApiV1BannerBanneridLangs.ts";

export const getApiV1BannerBanneridLangsQueryKey = (
  bannerId: GetApiV1BannerBanneridLangsPathParams["bannerId"],
  params?: GetApiV1BannerBanneridLangsQueryParams,
) =>
  [
    { url: "/api/v1/banner/:bannerId/langs", params: { bannerId: bannerId } },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1BannerBanneridLangsQueryKey = ReturnType<
  typeof getApiV1BannerBanneridLangsQueryKey
>;

export function getApiV1BannerBanneridLangsQueryOptions(
  bannerId: GetApiV1BannerBanneridLangsPathParams["bannerId"],
  params?: GetApiV1BannerBanneridLangsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1BannerBanneridLangsQueryKey(bannerId, params);
  return queryOptions<
    GetApiV1BannerBanneridLangsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1BannerBanneridLangs401
      | GetApiV1BannerBanneridLangs404
      | GetApiV1BannerBanneridLangs500
    >,
    GetApiV1BannerBanneridLangsQueryResponse,
    typeof queryKey
  >({
    enabled: !!bannerId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1BannerBanneridLangs(bannerId, params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna uma lista paginada das traduções (idiomas) do banner. **(Requer Authorization para autenticação)**
 * @summary Listar idiomas do banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner/:bannerId/langs}
 */
export function useGetApiV1BannerBanneridLangs<
  TData = GetApiV1BannerBanneridLangsQueryResponse,
  TQueryData = GetApiV1BannerBanneridLangsQueryResponse,
  TQueryKey extends QueryKey = GetApiV1BannerBanneridLangsQueryKey,
>(
  bannerId: GetApiV1BannerBanneridLangsPathParams["bannerId"],
  params?: GetApiV1BannerBanneridLangsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1BannerBanneridLangsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1BannerBanneridLangs401
          | GetApiV1BannerBanneridLangs404
          | GetApiV1BannerBanneridLangs500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1BannerBanneridLangsQueryKey(bannerId, params);

  const query = useQuery(
    {
      ...getApiV1BannerBanneridLangsQueryOptions(bannerId, params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1BannerBanneridLangs401
      | GetApiV1BannerBanneridLangs404
      | GetApiV1BannerBanneridLangs500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
